export default "__VITE_ASSET__CVhR57Zi__"